import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { UNIDADE_LOCAL_RFB_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    UNIDADE_LOCAL_RFB_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    UNIDADE_LOCAL_RFB_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [UNIDADE_LOCAL_RFB_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [UNIDADE_LOCAL_RFB_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [UNIDADE_LOCAL_RFB_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [UNIDADE_LOCAL_RFB_ENDPOINT],
    id
  );
}
